export default __webpack_public_path__ + "97ee3d3ebf63ad4196160fea1f14a738.png";